
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("c4Cbx", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $75Pwq = parcelRequire("75Pwq");


var $gkYRS = parcelRequire("gkYRS");


var $eavF5 = parcelRequire("eavF5");

const $cdb1236235110757$var$DatePicker = (0, $75Pwq.componentWithCondition)(()=>(0, $dh538.fg)('dst-date-picker-use-functional-component'), (0, $eavF5.default), (0, $gkYRS.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cdb1236235110757$export$2e2bcd8739ae039 = $cdb1236235110757$var$DatePicker;
module.exports["default"] = $cdb1236235110757$export$2e2bcd8739ae039;

});

parcelRegister("75Pwq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $dc6d37b9ef0ba7b4$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        condition() ? /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $dc6d37b9ef0ba7b4$export$6e8ea24b15199873;

});

parcelRegister("gkYRS", function(module, exports) {
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");


var $eWRwJ = parcelRequire("eWRwJ");

var $ggbZE = parcelRequire("ggbZE");

var $1DWH0 = parcelRequire("1DWH0");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $c0qxy = parcelRequire("c0qxy");


var $9RVYh = parcelRequire("9RVYh");


var $9KYtE = parcelRequire("9KYtE");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2gD2K = parcelRequire("2gD2K");

var $eKXGE = parcelRequire("eKXGE");


var $2oOe7 = parcelRequire("2oOe7");


var $huehD = parcelRequire("huehD");


var $53oCz = parcelRequire("53oCz");


var $813W4 = parcelRequire("813W4");


var $afQaI = parcelRequire("afQaI");


var $cda8t = parcelRequire("cda8t");

function $dcb2c3debbb79a5d$var$_defineProperty(e, r, t) {
    return (r = $dcb2c3debbb79a5d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $dcb2c3debbb79a5d$var$_toPropertyKey(t) {
    var i = $dcb2c3debbb79a5d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $dcb2c3debbb79a5d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /// <reference types="node" />
const $dcb2c3debbb79a5d$var$packageName = "platform-pkg";
const $dcb2c3debbb79a5d$var$packageVersion = "0.0.0-use.local";
const $dcb2c3debbb79a5d$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $dcb2c3debbb79a5d$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $dcb2c3debbb79a5d$export$df43d21f5faca9f7 extends (0, $42omo.Component) {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $9KYtE.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($9RVYh))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $dcb2c3debbb79a5d$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $2oOe7.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $53oCz.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $813W4.Menu,
            // SingleValue is defined in the render because of UI generator limitations
            ...!showClearIndicator && {
                ClearIndicator: (0, $2oOe7.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, #091E424F)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $afQaI.getShortISOString)((0, $da71s.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $huehD.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $gMc0m.default)([
                $dcb2c3debbb79a5d$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                (0, $dh538.fg)('platform-dtp_a11y_fix-dsp-23950') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c0qxy.IdProvider), {
                    children: ({ id: valueId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                            appearance: this.props.appearance,
                            "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                            label: label || undefined,
                            autoFocus: autoFocus,
                            clearControlLabel: clearControlLabel,
                            closeMenuOnSelect: true,
                            enableAnimation: false,
                            inputId: id,
                            inputValue: actualSelectInputValue,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            menuIsOpen: menuIsOpen,
                            onBlur: this.onSelectBlur,
                            onChange: this.onSelectChange,
                            onFocus: this.onSelectFocus,
                            onInputChange: this.handleSelectInputChange,
                            placeholder: (0, $huehD.getPlaceholder)({
                                placeholder: this.props.placeholder,
                                l10n: this.state.l10n
                            }),
                            styles: mergedStyles,
                            value: initialValue,
                            ...selectProps,
                            // up when you alter some of the properties in the `selectComponents`
                            // object. These errors are still present, and I suspect have always
                            // been present, without changing the unrelated code. Ignoring as the
                            // component still works as expected despite this error. And also
                            // because the select refresh team may solve it later.
                            components: {
                                ...selectComponents,
                                SingleValue: (0, $cda8t.makeSingleValue)({
                                    id: valueId,
                                    lang: this.props.locale
                                })
                            },
                            // selectProps or not and what wil be overwritten
                            isClearable: true,
                            isInvalid: isInvalid,
                            spacing: spacing,
                            testId: testId,
                            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                            calendarContainerRef: calendarProps.calendarContainerRef,
                            calendarDisabled: calendarProps.calendarDisabled,
                            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                            calendarLocale: calendarProps.calendarLocale,
                            calendarMaxDate: calendarProps.calendarMaxDate,
                            calendarMinDate: calendarProps.calendarMinDate,
                            calendarRef: calendarProps.calendarRef,
                            calendarValue: calendarProps.calendarValue,
                            calendarView: calendarProps.calendarView,
                            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                            nextMonthLabel: nextMonthLabel,
                            onCalendarChange: calendarProps.onCalendarChange,
                            onCalendarSelect: calendarProps.onCalendarSelect,
                            previousMonthLabel: previousMonthLabel,
                            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                            menuInnerWrapper: calendarProps.menuInnerWrapper
                        })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $huehD.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: {
                        ...selectComponents,
                        SingleValue: (0, $cda8t.makeSingleValue)({
                            lang: this.props.locale
                        })
                    },
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c0qxy.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($dcb2c3debbb79a5d$var$styles.iconContainerStyles, value && !hideIcon ? $dcb2c3debbb79a5d$var$styles.iconSpacingWithClearButtonStyles : $dcb2c3debbb79a5d$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9RVYh))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
    constructor(props){
        super(props);
        $dcb2c3debbb79a5d$var$_defineProperty(this, "containerRef", null);
        $dcb2c3debbb79a5d$var$_defineProperty(this, "calendarRef", /*#__PURE__*/ (0, $42omo.createRef)());
        $dcb2c3debbb79a5d$var$_defineProperty(this, "calendarButtonRef", /*#__PURE__*/ (0, $42omo.createRef)()); // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        $dcb2c3debbb79a5d$var$_defineProperty(this, "getValue", ()=>this.props.value ?? this.state.value);
        $dcb2c3debbb79a5d$var$_defineProperty(this, "getIsOpen", ()=>this.props.isOpen ?? this.state.isOpen);
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onCalendarChange", ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $huehD.getParsedISO)({
                    iso: iso
                })
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onCalendarSelect", ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onInputClick", ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onContainerBlur", (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onContainerFocus", ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onSelectBlur", (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onSelectFocus", (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onTextInput", (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $huehD.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $cFEpk.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $afQaI.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onInputKeyDown", (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $huehD.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $afQaI.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onCalendarButtonKeyDown", (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        }); // This event handler is triggered from both keydown and click. It's weird.
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onCalendarButtonClick", (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onClear", ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $afQaI.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        }); // `unknown` is used because `value` is unused so it does not matter.
        $dcb2c3debbb79a5d$var$_defineProperty(this, "onSelectChange", (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "handleSelectInputChange", (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        });
        $dcb2c3debbb79a5d$var$_defineProperty(this, "getContainerRef", (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        });
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $afQaI.getShortISOString)(new Date()),
            l10n: (0, $9KYtE.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
}
$dcb2c3debbb79a5d$var$_defineProperty($dcb2c3debbb79a5d$export$df43d21f5faca9f7, "defaultProps", $dcb2c3debbb79a5d$var$datePickerDefaultProps);
const $dcb2c3debbb79a5d$var$DatePicker = (0, $ggbZE.default)({
    componentName: 'datePicker',
    packageName: $dcb2c3debbb79a5d$var$packageName,
    packageVersion: $dcb2c3debbb79a5d$var$packageVersion
})((0, $1DWH0.default)({
    onChange: (0, $eWRwJ.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $dcb2c3debbb79a5d$var$packageName,
            packageVersion: $dcb2c3debbb79a5d$var$packageVersion
        }
    })
})($dcb2c3debbb79a5d$export$df43d21f5faca9f7));
var $dcb2c3debbb79a5d$export$2e2bcd8739ae039 = $dcb2c3debbb79a5d$var$DatePicker;
module.exports["default"] = $dcb2c3debbb79a5d$export$2e2bcd8739ae039;

});

parcelRegister("9KYtE", function(module, exports) {

var $kZZJD = parcelRequire("kZZJD");


var $fimv6 = parcelRequire("fimv6");


var $ekA6C = parcelRequire("ekA6C");

const $33f16c2c57b5906d$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $kZZJD.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $fimv6.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $ekA6C.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $ekA6C.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $33f16c2c57b5906d$export$ea56ca58f08ffa52;

});

parcelRegister("kZZJD", function(module, exports) {
const $afb1d33712cd2f2f$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $afb1d33712cd2f2f$export$dca0327c9b9c6498;

});

parcelRegister("fimv6", function(module, exports) {

var $kZZJD = parcelRequire("kZZJD");


var $2h5MO = parcelRequire("2h5MO");

const $de7c077ce1369583$var$INVALID_DATE = new Date(NaN);
const $de7c077ce1369583$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $de7c077ce1369583$var$INVARIANT_DATE = (0, $2h5MO.toDate)($de7c077ce1369583$var$INVARIANT);
const $de7c077ce1369583$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $de7c077ce1369583$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $de7c077ce1369583$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $de7c077ce1369583$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $de7c077ce1369583$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $kZZJD.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($de7c077ce1369583$var$INVARIANT_DATE);
    const shortDate = $de7c077ce1369583$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($de7c077ce1369583$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $de7c077ce1369583$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($de7c077ce1369583$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($de7c077ce1369583$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($de7c077ce1369583$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $de7c077ce1369583$var$stripExtras(date).match($de7c077ce1369583$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $de7c077ce1369583$var$INVALID_DATE;
        const dateParts = $de7c077ce1369583$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $2h5MO.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $2h5MO.isValid)(normalizedDate)) return $de7c077ce1369583$var$INVALID_DATE;
        return (0, $2h5MO.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $de7c077ce1369583$export$cfa2ef2687faeda2;

});

parcelRegister("2h5MO", function(module, exports) {
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $312c560df75c9b9c$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $312c560df75c9b9c$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $312c560df75c9b9c$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $312c560df75c9b9c$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $312c560df75c9b9c$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $312c560df75c9b9c$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $312c560df75c9b9c$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $312c560df75c9b9c$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $312c560df75c9b9c$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["toDate"] = $312c560df75c9b9c$export$e67a095c620b86fe;
module.exports["isValid"] = $312c560df75c9b9c$export$1ea939691cdc45b8;
module.exports["normalizeDate"] = $312c560df75c9b9c$export$fcc71269590ba0a8;

});

parcelRegister("ekA6C", function(module, exports) {
const $d6d12117fc0f7cb0$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $d6d12117fc0f7cb0$export$9b7ca29af37c192;

});

parcelRegister("2oOe7", function(module, exports) {
/**
 * This component is used to hide portions of Select component.
 */ const $65b9c14f421da27f$export$5e30e9a24d6c1203 = ()=>null;
const $65b9c14f421da27f$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $65b9c14f421da27f$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $65b9c14f421da27f$export$9e6d8fcf62256b85 = 'h:mma';
const $65b9c14f421da27f$export$75032c84f56650eb = 'YYYY/MM/DD';
function $65b9c14f421da27f$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $65b9c14f421da27f$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}
module.exports["EmptyComponent"] = $65b9c14f421da27f$export$5e30e9a24d6c1203;
module.exports["placeholderDatetime"] = $65b9c14f421da27f$export$fff8babee5abe3e2;
module.exports["defaultTimes"] = $65b9c14f421da27f$export$b42ffb9f09b1861b;
module.exports["defaultTimeFormat"] = $65b9c14f421da27f$export$9e6d8fcf62256b85;
module.exports["defaultDateFormat"] = $65b9c14f421da27f$export$75032c84f56650eb;
module.exports["padToTwo"] = $65b9c14f421da27f$export$a7de57e5b672ccdb;
module.exports["formatDateTimeZoneIntoIso"] = $65b9c14f421da27f$export$2eeb05a2ecc2ce0a;

});

parcelRegister("huehD", function(module, exports) {
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $dWCFT = parcelRequire("dWCFT");

var $jqWS9 = parcelRequire("jqWS9");

var $da71s = parcelRequire("da71s");


var $7lMCw = parcelRequire("7lMCw");


var $2oOe7 = parcelRequire("2oOe7");

const $85f2897621056512$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $85f2897621056512$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $jqWS9.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $2oOe7.padToTwo)(parsedMonth)}-${(0, $2oOe7.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $2oOe7.padToTwo)(parsedMonth)}-${(0, $2oOe7.padToTwo)(parsedDate)}`;
    return newIso;
};
const $85f2897621056512$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $2oOe7.defaultDateFormat));
    return l10n.parseDate(date);
};
const $85f2897621056512$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $2oOe7.defaultDateFormat));
    const date = (0, $da71s.default)(value);
    return dateFormat ? (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $85f2897621056512$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $2oOe7.placeholderDatetime));
};
module.exports["isDateDisabled"] = $85f2897621056512$export$d38e7e283938128c;
module.exports["getParsedISO"] = $85f2897621056512$export$38db26406d1a1ee2;
module.exports["parseDate"] = $85f2897621056512$export$6b862160d295c8e;
module.exports["formatDate"] = $85f2897621056512$export$3ae94a2503e890a1;
module.exports["getPlaceholder"] = $85f2897621056512$export$d3f5c5e0a5023fa0;

});

parcelRegister("jqWS9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e25e1cd73cddce6c$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $e25e1cd73cddce6c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("7lMCw", function(module, exports) {
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $b5826e8cf22189ea$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $b5826e8cf22189ea$var$v1tokens = Object.keys($b5826e8cf22189ea$var$tokensMap).sort().reverse();
const $b5826e8cf22189ea$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$b5826e8cf22189ea$var$v1tokens.join('|') + '|.)', 'g');
function $b5826e8cf22189ea$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($b5826e8cf22189ea$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $b5826e8cf22189ea$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}
module.exports["convertTokens"] = $b5826e8cf22189ea$export$4d5430175be73d45;

});

parcelRegister("53oCz", function(module, exports) {
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3hOY6 = parcelRequire("3hOY6");

const $c26bf47b337ba3d5$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $c26bf47b337ba3d5$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            showClearIndicator ? $c26bf47b337ba3d5$var$styles.calendarButtonInclusionStyles : $c26bf47b337ba3d5$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).IndicatorsContainer, {
            ...rest
        })
    });
module.exports["IndicatorsContainer"] = $c26bf47b337ba3d5$export$d0ffd7e649cab6f;

});

parcelRegister("813W4", function(module, exports) {
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");


var $91bEl = parcelRequire("91bEl");


var $iug2J = parcelRequire("iug2J");


var $hq1yX = parcelRequire("hq1yX");

function $25a48d284d5ccc39$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $da71s.default)(iso);
        return (0, $cFEpk.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $25a48d284d5ccc39$var$menuStyles = null; /**
                          * This is the menu used in the select of the date picker.
                          */ 
const $25a48d284d5ccc39$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $25a48d284d5ccc39$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hq1yX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $gMc0m.default)([
                    "_2rko12b0 _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $91bEl.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};
module.exports["Menu"] = $25a48d284d5ccc39$export$d9b273488cd8ce6f;

});

parcelRegister("91bEl", function(module, exports) {
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $2XUih = parcelRequire("2XUih");


var $bR9Dp = parcelRequire("bR9Dp");


var $a6vtp = parcelRequire("a6vtp");


var $2ack0 = parcelRequire("2ack0");


var $3oVyw = parcelRequire("3oVyw");


var $cKHjJ = parcelRequire("cKHjJ");


var $3PoNw = parcelRequire("3PoNw");


var $fwvxa = parcelRequire("fwvxa");


var $gGqGY = parcelRequire("gGqGY");


var $1YcZ7 = parcelRequire("1YcZ7");

const $d7a40ddbec5b8284$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d7a40ddbec5b8284$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d7a40ddbec5b8284$var$InnerCalendar = /*#__PURE__*/ (0, $42omo.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $2ack0.blankStringArray), defaultSelected: defaultSelected = (0, $2ack0.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $ee7An.default), onChange: onChange = (0, $ee7An.default), onFocus: onFocus = (0, $ee7An.default), onSelect: onSelect = (0, $ee7An.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $3oVyw.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $42omo.useState)(false);
    const onChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d7a40ddbec5b8284$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $fwvxa.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d7a40ddbec5b8284$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $gGqGY.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $cKHjJ.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $1YcZ7.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $3PoNw.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $c0qxy.useId)();
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $d7a40ddbec5b8284$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2XUih.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $a6vtp.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $bR9Dp.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    });
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d7a40ddbec5b8284$var$Calendar = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($d7a40ddbec5b8284$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d7a40ddbec5b8284$var$Calendar.displayName = 'Calendar';
var $d7a40ddbec5b8284$export$2e2bcd8739ae039 = $d7a40ddbec5b8284$var$Calendar;
module.exports["default"] = $d7a40ddbec5b8284$export$2e2bcd8739ae039;

});

parcelRegister("2XUih", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $c0qxy = parcelRequire("c0qxy");


var $7hXDW = parcelRequire("7hXDW");


var $ey1uv = parcelRequire("ey1uv");


var $iSulU = parcelRequire("iSulU");


var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

const $56c413dce376864e$var$Header = /*#__PURE__*/ (0, $42omo.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $c0qxy.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $42omo.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ey1uv))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSulU))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$56c413dce376864e$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$56c413dce376864e$export$2e2bcd8739ae039 = $56c413dce376864e$var$Header;
module.exports["default"] = $56c413dce376864e$export$2e2bcd8739ae039;

});

parcelRegister("bR9Dp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");


var $hKrof = parcelRequire("hKrof");


var $dY80g = parcelRequire("dY80g");

const $4ba945c9b05a81e4$var$WeekDays = /*#__PURE__*/ (0, $42omo.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dY80g.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hKrof.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$4ba945c9b05a81e4$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ba945c9b05a81e4$export$2e2bcd8739ae039 = $4ba945c9b05a81e4$var$WeekDays;
module.exports["default"] = $4ba945c9b05a81e4$export$2e2bcd8739ae039;

});

parcelRegister("hKrof", function(module, exports) {
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ee7An = parcelRequire("ee7An");


var $d8SNb = parcelRequire("d8SNb");

const $51ea448395b49484$var$dateCellSiblingStyle = null;
const $51ea448395b49484$var$dateCellTodayStyle = null;
const $51ea448395b49484$var$dateCellPrevSelectedStyle = null;
const $51ea448395b49484$var$dateCellSelectedStyle = null;
const $51ea448395b49484$var$dateCellDisabledStyle = null;
const $51ea448395b49484$var$dateCellStyles = null;
const $51ea448395b49484$var$Date = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $ee7An.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $42omo.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $gMc0m.default)([
                "_kkk2n7od _2rkofajl _11c82smr _1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk1j28 _syaz1fxt _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj1p6i _10knnqa1 _1wysdkaa _irr3166n _30l31fxt _1di61dty _9h8h1fxt",
                isSibling && "_syaz131l _30l3131l",
                isToday && "_syazaqb7 _k48pmoej _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhkfg4m _syaz1gjq _30l31gjq",
                isSelected && "_bfhkfg4m _syazaqb7 _irr3i1yw _30l3aqb7",
                isDisabled && "_syaz1lh4 _80om13gf _irr31j28 _30l31lh4"
            ]),
            children: day
        })
    });
}));
$51ea448395b49484$var$Date.displayName = 'Date'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $51ea448395b49484$export$2e2bcd8739ae039 = $51ea448395b49484$var$Date;
module.exports["default"] = $51ea448395b49484$export$2e2bcd8739ae039;

});

parcelRegister("dY80g", function(module, exports) {
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d8SNb = parcelRequire("d8SNb");

const $43425f893909ddbd$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $43425f893909ddbd$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
        testId: testId,
        xcss: $43425f893909ddbd$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $43425f893909ddbd$export$2e2bcd8739ae039 = $43425f893909ddbd$var$WeekDayGrid;
module.exports["default"] = $43425f893909ddbd$export$2e2bcd8739ae039;

});

parcelRegister("a6vtp", function(module, exports) {
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $dY80g = parcelRequire("dY80g");

const $a885473fdfbb1dd4$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $a885473fdfbb1dd4$var$WeekHeader = /*#__PURE__*/ (0, $42omo.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dY80g.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                padding: "space.100",
                xcss: $a885473fdfbb1dd4$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$a885473fdfbb1dd4$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a885473fdfbb1dd4$export$2e2bcd8739ae039 = $a885473fdfbb1dd4$var$WeekHeader;
module.exports["default"] = $a885473fdfbb1dd4$export$2e2bcd8739ae039;

});

parcelRegister("2ack0", function(module, exports) {
const $9af94d164628a3a8$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $9af94d164628a3a8$export$3ae905d9742bef55 = 7;
const $9af94d164628a3a8$export$c9b7c010035d60c6 = 12;
const $9af94d164628a3a8$export$8fa20d70624f8b9d = [];
module.exports["arrowKeys"] = $9af94d164628a3a8$export$8b15eca9c6d5c48a;
module.exports["daysPerWeek"] = $9af94d164628a3a8$export$3ae905d9742bef55;
module.exports["monthsPerYear"] = $9af94d164628a3a8$export$c9b7c010035d60c6;
module.exports["blankStringArray"] = $9af94d164628a3a8$export$8fa20d70624f8b9d;

});

parcelRegister("3oVyw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea43d7ef0e095eed$export$2e2bcd8739ae039);

var $6mkwk = parcelRequire("6mkwk");


var $9GKca = parcelRequire("9GKca");


var $6Nn7f = parcelRequire("6Nn7f");

function $ea43d7ef0e095eed$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9GKca.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $6mkwk.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $6mkwk.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $6mkwk.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $6mkwk.default)(today, ()=>today || `${thisYear}-${(0, $6Nn7f.default)(thisMonth)}-${(0, $6Nn7f.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $6mkwk.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $6mkwk.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});

parcelRegister("6Nn7f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f02dc32cc8cbca94$export$2e2bcd8739ae039);
function $f02dc32cc8cbca94$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});

parcelRegister("cKHjJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dddbc69a80aa3e99$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $dddbc69a80aa3e99$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $42omo.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $42omo.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("3PoNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0359114b86aba571$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $da71s = parcelRequire("da71s");


var $2ack0 = parcelRequire("2ack0");


var $h8WCF = parcelRequire("h8WCF");


var $4SC50 = parcelRequire("4SC50");

function $0359114b86aba571$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $42omo.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $2ack0.daysPerWeek) : 0;
            return (0, $4SC50.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $2ack0.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
        return [];
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0359114b86aba571$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $42omo.useMemo)(()=>(0, $4SC50.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0359114b86aba571$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $da71s.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $da71s.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $42omo.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $h8WCF.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $da71s.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});

parcelRegister("h8WCF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e56c786f8652328$export$2e2bcd8739ae039);

var $6Nn7f = parcelRequire("6Nn7f");

function $2e56c786f8652328$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $6Nn7f.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $6Nn7f.default)(date.day)}`;
}

});

parcelRegister("4SC50", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a2ab129b65a12d$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $2ack0 = parcelRequire("2ack0");


var $b1Uz6 = parcelRequire("b1Uz6");

function $73a2ab129b65a12d$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $2ack0.daysPerWeek) - weekStartDay + firstDay) % (0, $2ack0.daysPerWeek));
    const lastDate = (0, $b1Uz6.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $2ack0.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $b1Uz6.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $2ack0.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $2ack0.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $2ack0.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $2ack0.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $2ack0.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});

parcelRegister("b1Uz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bc5f72de966b731$export$2e2bcd8739ae039);
function $2bc5f72de966b731$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});

parcelRegister("fwvxa", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bae543de1d5a89e$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2ack0 = parcelRequire("2ack0");


var $h8WCF = parcelRequire("h8WCF");


var $b1Uz6 = parcelRequire("b1Uz6");

const $4bae543de1d5a89e$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $2ack0.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $4bae543de1d5a89e$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $2ack0.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $4bae543de1d5a89e$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $42omo.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $42omo.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $h8WCF.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $42omo.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $2ack0.daysPerWeek);
            const daysInMonth = (0, $b1Uz6.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $4bae543de1d5a89e$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $4bae543de1d5a89e$var$getPrevMonth(month, year);
                const prevDay = (0, $b1Uz6.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $b1Uz6.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $4bae543de1d5a89e$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $2ack0.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $4bae543de1d5a89e$var$getPrevMonth(month, year);
                const prevDay = (0, $b1Uz6.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$4bae543de1d5a89e$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$4bae543de1d5a89e$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $42omo.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("gGqGY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d692683ec562e03$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2ack0 = parcelRequire("2ack0");


var $h8WCF = parcelRequire("h8WCF");

function $9d692683ec562e03$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $42omo.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $42omo.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $42omo.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $h8WCF.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $42omo.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $42omo.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $2ack0.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("1YcZ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a9118030077bfb7$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $9KYtE = parcelRequire("9KYtE");

function $8a9118030077bfb7$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $42omo.useMemo)(()=>(0, $9KYtE.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $42omo.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $42omo.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $42omo.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});

parcelRegister("hq1yX", function(module, exports) {
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $SZOxu = parcelRequire("SZOxu");


var $2xusd = parcelRequire("2xusd");

var $lqsSp = parcelRequire("lqsSp");

var $cs0ez = parcelRequire("cs0ez");

function $c20f43530238761f$var$_defineProperty(e, r, t) {
    return (r = $c20f43530238761f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c20f43530238761f$var$_toPropertyKey(t) {
    var i = $c20f43530238761f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c20f43530238761f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $c20f43530238761f$var$styles = {
    root: "_bfhk1j28 _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $c20f43530238761f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props; // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $l998X.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $SZOxu.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $l998X.jsxs)((0, $2xusd.Manager), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $gMc0m.default)([
                                $c20f43530238761f$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lqsSp.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ref: ref,
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $gMc0m.default)([
                                $c20f43530238761f$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args);
        $c20f43530238761f$var$_defineProperty(this, "update", (0, $ee7An.default));
    }
}
module.exports["default"] = $c20f43530238761f$export$2e2bcd8739ae039;

});

parcelRegister("afQaI", function(module, exports) {

var $dWCFT = parcelRequire("dWCFT");


var $7lMCw = parcelRequire("7lMCw");

function $3a91e7335c61042e$export$77d5bc49fed7ef14(date) {
    return (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)('YYYY-MM-DD'));
}
function $3a91e7335c61042e$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $3a91e7335c61042e$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}
module.exports["getShortISOString"] = $3a91e7335c61042e$export$77d5bc49fed7ef14;
module.exports["getSafeCalendarValue"] = $3a91e7335c61042e$export$ff525416014fb67d;

});

parcelRegister("cda8t", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $3hOY6 = parcelRequire("3hOY6");

const $ca1b90749f7f26ad$export$6e30bf8cb1347b56 = // TODO: Make ID required
({ id: id, lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                ...(0, $dh538.fg)('platform-dtp_a11y_fix-dsp-23950') ? {
                    id: id
                } : {},
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };
module.exports["makeSingleValue"] = $ca1b90749f7f26ad$export$6e30bf8cb1347b56;

});

parcelRegister("eavF5", function(module, exports) {
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");


var $gxtzC = parcelRequire("gxtzC");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $c0qxy = parcelRequire("c0qxy");


var $9RVYh = parcelRequire("9RVYh");


var $9KYtE = parcelRequire("9KYtE");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $2gD2K = parcelRequire("2gD2K");

var $eKXGE = parcelRequire("eKXGE");


var $2oOe7 = parcelRequire("2oOe7");


var $huehD = parcelRequire("huehD");


var $53oCz = parcelRequire("53oCz");


var $813W4 = parcelRequire("813W4");


var $afQaI = parcelRequire("afQaI");


var $cda8t = parcelRequire("cda8t");

const $7010dbb7432366df$var$packageName = "platform-pkg";
const $7010dbb7432366df$var$packageVersion = "0.0.0-use.local";
const $7010dbb7432366df$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $7010dbb7432366df$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $7010dbb7432366df$var$packageName,
    packageVersion: $7010dbb7432366df$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $7010dbb7432366df$var$DatePicker = /*#__PURE__*/ (0, $42omo.forwardRef)((props, _forwardedRef)=>{
    const containerRef = (0, $42omo.useRef)(null);
    const calendarRef = (0, $42omo.useRef)(null);
    const calendarButtonRef = (0, $42omo.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($9RVYh))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: /* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: /* eslint-enable @repo/internal/react/use-noop */ selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $42omo.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $42omo.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $42omo.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $42omo.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $42omo.useState)(propValue || defaultValue || (0, $afQaI.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $42omo.useState)((0, $9KYtE.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $42omo.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $42omo.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $42omo.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $42omo.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $42omo.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$7010dbb7432366df$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $9KYtE.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $42omo.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $huehD.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $huehD.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $cFEpk.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $afQaI.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $huehD.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $afQaI.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $afQaI.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $42omo.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    if ((0, $dh538.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $7010dbb7432366df$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const valueId = (0, $c0qxy.useId)();
    const SingleValue = (0, $cda8t.makeSingleValue)({
        id: valueId,
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $2oOe7.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $53oCz.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $813W4.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $2oOe7.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, #091E424F)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $afQaI.getShortISOString)((0, $da71s.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $huehD.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $c0qxy.useId)()}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $gMc0m.default)([
            $7010dbb7432366df$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                appearance: appearance,
                "aria-describedby": (0, $dh538.fg)('platform-dtp_a11y_fix-dsp-23950') ? ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId : ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $huehD.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($7010dbb7432366df$var$styles.iconContainerStyles, value && !hideIcon ? $7010dbb7432366df$var$styles.iconSpacingWithClearButtonStyles : $7010dbb7432366df$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9RVYh))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $7010dbb7432366df$export$2e2bcd8739ae039 = $7010dbb7432366df$var$DatePicker;
module.exports["default"] = $7010dbb7432366df$export$2e2bcd8739ae039;

});


$parcel$global.rlb("aeEUI")
//# sourceMappingURL=modal.38e72850.js.map
